const Logo = () => {
	return <img src="/assets/images/logo.png" alt="Logo" className="md:w-[12rem] md:h-[2rem] mb-2" />;
};

export default Logo;
